import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { AI_MODEL, SEO_AI_META } from '@makyoapp/makyo-common'
import { Chip, SelectDropdown } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

/**
 * handle select meta type field for AISEO column type
 */
function FieldMetaTags() {
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <Fld>
      <Lbl>
        <Trans>Meta Tags</Trans>
      </Lbl>
      {SEO_AI_META.map((meta) => {
        return (
          <Chip
            id={`${id}-seo-ai-meta-${meta}`}
            key={meta}
            active={value.seoAiOptions.seoAiMeta === meta}
            onClick={() =>
              setValue({
                seoAiOptions: {
                  ...value.seoAiOptions,
                  seoAiMeta: meta,
                },
              })
            }
          >
            <Trans>{meta === 'keywords' ? 'Keywords' : 'Page Description'}</Trans>
          </Chip>
        )
      })}
    </Fld>
  )
}

/**
 * handle source column field for AISEO column type
 */
function FieldTextColumn() {
  const { id, value, setValue } = useCreateColumnContext()
  const selected = value.seoAiOptions.seoAiColumn
  const { t } = useTranslation()

  return (
    <Fld>
      <Lbl>
        <Trans>Text Column</Trans>
      </Lbl>
      <ColumnDd
        id={`${id}-seo-ai-column`}
        placeholder={t('Select Column')}
        types={[ColumnTypes.RichText, ColumnTypes.Text]}
        selected={selected}
        onChange={(opt) => {
          setValue({
            seoAiOptions: {
              ...value.seoAiOptions,
              seoAiColumn: opt.id,
            },
          })
        }}
      />
    </Fld>
  )
}

/**
 * handle select model field for AISEO column type
 */
function FieldModel() {
  const { id, value, setValue } = useCreateColumnContext()

  return (
    <Fld>
      <Lbl>
        <Trans>AI Model</Trans>
      </Lbl>
      <SelectDropdown
        id={`${id}-seo-ai-model`}
        menuDefaultSize={false}
        menuClassName={'max-h-[220px] overflow-y-auto'}
        menuContainerClassName='mk-ag-sdd'
        menuZIndex='z-305'
        withSearch
        portalMenu
        onChange={(opt) => {
          setValue({
            seoAiOptions: {
              ...value.seoAiOptions,
              seoAiModel: opt,
            },
          })
        }}
        value={value.seoAiOptions.seoAiModel}
        options={AI_MODEL}
      />
    </Fld>
  )
}

/**
 * handle all fields for AISEO column type
 */
export default function FieldSeoAI() {
  return (
    <>
      <FieldMetaTags />
      <FieldTextColumn />
      <FieldModel />
    </>
  )
}
